import {
  Badge,
  type BadgeProps,
  Grid,
  type GridProps,
  ListItem,
  Typography,
  type TypographyProps
} from '@mui/material'
import React from 'react'

import { mergeSx } from 'utils/mui-components/merge-sx'

export interface TutorialStepProps extends Omit<GridProps, 'title'> {
  title: React.ReactNode
  titleProps?: TypographyProps
  badgeNumber?: number
  badgeProps?: BadgeProps
}

export const TutorialStep = ({
  title,
  titleProps,
  badgeNumber,
  badgeProps,
  children,
  ...gridContainerProps
}: TutorialStepProps) => {
  const { sx, ...restGridContainerProps } = gridContainerProps
  const sxMerged = mergeSx({ columnGap: 2, ml: 1, mt: 1 }, sx)

  return (
    <ListItem disablePadding>
      <Grid
        container
        data-testid={`prepare-to-define-services-tutorial-step-${badgeNumber}`}
        direction="row"
        sx={sxMerged}
        {...restGridContainerProps}
      >
        <Grid item mt={0.3}>
          <Badge
            badgeContent={badgeNumber}
            color="tutorialStep"
            {...badgeProps}
          />
        </Grid>
        <Grid item xs={11}>
          <Typography
            color="tutorialStep.main"
            data-testid={`prepare-to-define-services-tutorial-step-${badgeNumber}-title`}
            variant="h6"
            {...titleProps}
          >
            {title}
          </Typography>
          {children}
        </Grid>
      </Grid>
    </ListItem>
  )
}
